import Dropdown from "react-bootstrap/Dropdown";
import React, { useEffect, useState } from "react";
import { PatientService } from "../../services";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

const Favourite = (props) => {
  let color = "black";
  let star = "fa-star";
  const fav = props.fav?.toString();
  if (fav === "0") {
    star = "fa-star-o";
  } else if (fav === "1") {
    color = "blue";
  } else if (fav === "2") {
    color = "red";
  } else if (fav === "3") {
    color = "black";
  }

  return <i style={{ color: color }} className={`fa ${star}`}></i>;
};

const FavouriteDropdown = (props) => {
  const [current, updateCurrent] = useState(props.fav);

  useEffect(() => {
    updateCurrent(props.fav)
  }, [ props.fav ])

  const updateFavourite = (fav) => {
    PatientService.setFavourite(props.patientId, fav);
    updateCurrent(fav);
  };

  const createDropdownItem = (number) => {
    return (
      <Dropdown.Item
        key={number}
        onClick={() => {
          updateFavourite(number);
        }}
      >
        <Favourite fav={number} />
      </Dropdown.Item>
    );
  };

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        <Favourite fav={current} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
          {[...Array(4).keys()].map((i) => createDropdownItem(i))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FavouriteDropdown;
